<mat-form-field
  *ngIf="filterFormControl"
  appearance="fill"
  class="org-filter-field full-width"
>
  <input
    class="filter"
    matInput
    placeholder="Click or start typing to filter"
    aria-label="Filter by Line of Business"
    [formControl]="filterFormControl"
    (focus)="onInputFocus()"
    (click)="onInputFocus()"
  />

  <button
    type="button"
    *ngIf="hasTypedFilter"
    matSuffix
    mat-icon-button
    aria-label="Clear Line of Business filter"
    (click)="clearFilter()"
  >
    <mat-icon>close</mat-icon>
  </button>

  <mat-hint *ngIf="!hasTypedFilter"> {{ helperText }} </mat-hint>

  <mat-hint *ngIf="hasTypedFilter"> {{ typedHint }} </mat-hint>
</mat-form-field>
